import React, {useState, useEffect} from 'react';
import {Routes, Route} from 'react-router-dom';
import {connect} from 'react-redux';

import Dashboard from '@app/pages/dashboard/Dashboard';
import Profile from '@pages/profile/Profile';
import BackLog from '@app/pages/backlog/Backlog';
import RssFeed from '@app/pages/rss-feed/RssFeed';
import Scheduled from '@app/pages/scheduled/Scheduled';

import Header from './header/Header';
import Footer from './footer/Footer';
import MenuSidebar from './menu-sidebar/MenuSidebar';
import PageLoading from '../../components/page-loading/PageLoading';

const Main = () => {
    const [appLoadingState, updateAppLoading] = useState(false);
    const [menusidebarState, updateMenusidebarState] = useState({
        isMenuSidebarCollapsed: false
    });

    const toggleMenuSidebar = () => {
        updateMenusidebarState({
            isMenuSidebarCollapsed: !menusidebarState.isMenuSidebarCollapsed
        });
    };

    useEffect(() => {
        updateAppLoading(true);
        updateAppLoading(false);
        return () => {};
    }, []);

    document.getElementById('root').classList.remove('register-page');
    document.getElementById('root').classList.remove('login-page');
    document.getElementById('root').classList.remove('hold-transition');

    document.getElementById('root').className += ' sidebar-mini';

    if (menusidebarState.isMenuSidebarCollapsed) {
        document.getElementById('root').classList.add('sidebar-collapse');
        document.getElementById('root').classList.remove('sidebar-open');
    } else {
        document.getElementById('root').classList.add('sidebar-open');
        document.getElementById('root').classList.remove('sidebar-collapse');
    }

    let template;

    if (appLoadingState) {
        template = <PageLoading />;
    } else {
        template = (
            <>
                <Header toggleMenuSidebar={toggleMenuSidebar} />

                <MenuSidebar />

                <div className="content-wrapper">
                    <div className="pt-3" />
                    <section className="content">
                        <Routes>
                            <Route path="/profile" element={<Profile />} />
                            <Route path="/backlog/*" element={<BackLog />} />
                            <Route path="/rss-feed/*" element={<RssFeed />} />
                            <Route path="/scheduled/*" element={<Scheduled />} />
                            <Route path="/" element={<Dashboard />} />
                        </Routes>
                    </section>
                </div>
                <Footer />
                <div
                    id="sidebar-overlay"
                    role="presentation"
                    onClick={toggleMenuSidebar}
                    onKeyDown={() => {}}
                />
            </>
        );
    }

    return <div className="wrapper">{template}</div>;
};

const mapStateToProps = (state) => ({
    user: state.auth.currentUser
});

export default connect(mapStateToProps, null)(Main);
